import React, { FC } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { Flex, Text } from '@moonpig/launchpad-components'
import { DepartmentsEnum } from '@moonpig/web-core-types-graphql'
import { InspirationRow, InspirationType } from '../types'
import { mapDepartmentToIcon } from '../mapDepartmentToIcon'

const StyledIconWrapper = styled(Flex)`
  align-items: center;

  ${s({
    borderRadius: '8px',
    color: 'colorInteractionControl',
  })}
`

const StyledTextWrapper = styled(Flex)`
  ${s({
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: 0, md: 4 },
  })}
`

const StyledText = styled(Text)`
  ${s({
    color: 'textLabel',
    lineHeight: '24px',
  })}
`

export const Inspiration: FC<{ row: InspirationRow }> = ({ row }) => {
  const item = row.item as InspirationType
  const capitalizedSearchTerm = `${item.searchTerm[0].toUpperCase()}${item.searchTerm?.slice(
    1,
  )}`

  const icon = mapDepartmentToIcon(item.department as DepartmentsEnum)

  return (
    <Flex alignItems="center" gap={8}>
      <StyledIconWrapper>{icon}</StyledIconWrapper>
      <StyledTextWrapper>
        <StyledText>{capitalizedSearchTerm}</StyledText>
      </StyledTextWrapper>
    </Flex>
  )
}
